<template>
  <div class="about_container">
    <!-- <page-top></page-top> -->
    <div class="content_wrap">
      <div class="son-page"></div>
      <div class="menu_wrap">
        <div class="about_wrap">
          <div :class="[{'act-item':activeIndex==0},'media_font_size_50']" @click="activeIndex=0">联系我们</div>
          <div :class="[{'act-item':activeIndex==1},'media_font_size_50']" @click="activeIndex=1">参展须知</div>
        </div>
        <div class="right_wrap" :style="{'fontSize':'14px'}">
          当前位置：
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>新闻中心</el-breadcrumb-item>
            <el-breadcrumb-item>{{activeIndex==0?'联系我们':'参展须知'}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <div class="contact_us" v-if="activeIndex==0">
        <img src="https://faststatic.ccnfgame.com/cos/vrshow/autoShow/about.png" alt />
        <div>
          <div class="about_title">
            <span>KEEP</span>
            <span>THE HEART - -</span>
          </div>
          <h2 class="media_font_size_50">广州国际汽车展览会</h2>
          <span class="media_line_height_40 media_font_size_50">电话：123456778990</span>
          <span class="media_line_height_40 media_font_size_50">邮箱：2222222@qq.com</span>
          <span class="media_line_height_40 media_font_size_50">地址：广州琶洲·广交会展馆</span>
          <div class="qr_wrap">
            <img
              src="https://faststatic.ccnfgame.com/cos/vrshow/autoShow/code.png"
              alt
            />
            <span>扫一扫</span>
            <span>关注公众号</span>
          </div>
        </div>
      </div>
      <div class="join_notice" v-if="activeIndex==1">
        <h1 class="media_font_size_70">参展须知标题</h1>
        <div>
          <span class="media_line_height_40 media_font_size_50">1、参展须知说明</span>
          <span class="media_line_height_40 media_font_size_50">2、参展须知说明</span>
          <span class="media_line_height_40 media_font_size_50">3、参展须知说明</span>
        </div>
      </div>
    </div>
    <page-bottom></page-bottom>
  </div>
</template>

<script>
import pageTop from "@/components/pageTop";
import pageBottom from "@/components/pageBottom";
export default {
  components: {
    pageTop,
    pageBottom
  },
  data() {
    return {
      activeIndex: this.$route.query.tab
    };
  },
  watch: {
    $route(to, from) {
      //监听路由是否变化
      if (to.query.tab != from.query.tab) {
        this.changeTabs(to.query.tab);
      }
    }
  },
  methods: {
    changeTabs(index) {
      this.activeIndex = index;
    }
  }
};
</script>

<style lang="scss">
.about_container {
  width: 100vw;
  min-height: 100vh;
  background: #221f26;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: default;
  justify-content: space-between;
  .content_wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .son-page {
    width: 1920px;
    height: 300px;
    background-image: url("https://faststatic.ccnfgame.com/cos/vrshow/autoShow/banner_5_1.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .menu_wrap {
    width: 1200px;
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .about_wrap {
      height: 100px;
      border-bottom: 1px solid rgba($color: #fff, $alpha: 0.2);
      box-sizing: border-box;
      display: flex;
      > div {
        font-size: 30px;
        // width: 143px;
        line-height: 100px;
        text-align: center;
        color: #ccc;
        border-bottom: 2px solid transparent;
        margin-right: 50px;
      }
      .act-item {
        color: #42abff;
        border-bottom: 1px solid #42abff;
      }
    }
    .right_wrap {
      display: flex;
      color: rgba(255, 255, 255, 0.8);
      align-items: center;
    }
  }
  .contact_us {
    width: 1200px;
    display: flex;
    align-items: center;
    margin-top: 60px;
    > img {
      width: 690px;
      height: 900px;
      margin-right: 60px;
    }
    > div {
      display: flex;
      flex-direction: column;
      .about_title {
        display: flex;
        flex-direction: column;
        color: #fff;
        margin-bottom: 52px;
        > span {
          font-size: 50px;
          font-weight: bold;
        }
        > span:first-child {
          color: #eb6c1f;
        }
      }
      > h2 {
        color: #ccc;
        font-size: 30px;
      }
      > span {
        color: #ccc;
        font-size: 24px;
        // line-height: 40px;
      }
      .qr_wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 90px;
        > img {
          width: 200px;
          height: 200px;
          margin-bottom: 20px;
        }
        > span {
          font-size: 20px;
          color: #999;
        }
      }
    }
  }
  .join_notice {
    width: 1200px;
    color: #fff;
    margin-top: 60px;
    > div {
      display: flex;
      flex-direction: column;
      > span {
        font-size: 20px;
        color: #ccc;
        // line-height: 40px;
        margin-bottom: 50px;
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .about_container {
    .content_wrap {
      .menu_wrap {
        width: 100vw;
        height: 200px;
        justify-content: center;
        .about_wrap {
          // width: 100%;
          // height: 200px;
        }
        .right_wrap {
          display: none;
        }
      }
      .contact_us{
        flex-direction: column;
        width: 100vw;
        >img{
          width:100vw;
          height: auto;
          margin:0;
        }
        >div{
          margin-top:230px;
          .about_title{
             >span{
            font-size: 150px;
          }
          }
         
        }
        .qr_wrap{
          >img{
            width: 50vw;
            height: auto;
          }
        }
      }
    }
  }
}
</style>

<style>
.about_container .el-breadcrumb__item .el-breadcrumb__inner {
  color: rgba(255, 255, 255, 0.8) !important;
}
</style>


// WEBPACK FOOTER //
// index.vue?2ed679d3